module.exports = __webpack_public_path__ + "img/menu-account-list.d602fec0.svg";